import { type Task, type ProjectPhase } from '@/generated/graphql';
import { defineStore } from 'pinia';
import { type UNGROUPED_TASKS_ID } from './constants';
import { type ValueOf } from '@/types';
import { TaskBundlePlacement } from './types';

type TaskListStoreType = {
	taskBundleOpen: ProjectPhase['id'] | typeof UNGROUPED_TASKS_ID | undefined;
	taskBundlePlacement: ValueOf<typeof TaskBundlePlacement>;
	subtaskBundleOpen: Task['id'] | undefined;
	editModeTaskId?: Task['id'];
};

export const useTaskListStore = defineStore('taskList', {
	state: (): TaskListStoreType => ({
		taskBundleOpen: undefined,
		taskBundlePlacement: TaskBundlePlacement.Top,
		subtaskBundleOpen: undefined,
		editModeTaskId: undefined,
	}),
});
